import React from 'react'
import { Button } from 'semantic-ui-react';

import styles from './transparentButton.module.css'



export const TransparentButton = (props) => {
    const btnClass = props.active ? `${styles.transparentButton} ${styles.active}` : styles.transparentButton;
    return (
        <Button fluid className={btnClass} onClick={() => props.handleItemClick()}>
            {props.children}
        </Button>
    )
}

export default TransparentButton


// WEBPACK FOOTER //
// ./src/components/transparentButton.jsx